/* ---------------------------------------------------------------------------
(c) 2023-2024, HID Global Corporation, part of ASSA ABLOY.
All rights reserved.

This program is an un published copyrighted work which is proprietary
to HID Global Corporation. This computer program includes Confidential,
Proprietary Information and is a Trade Secret of HID Global Corporation.
Any use, disclosure, modification and/or reproduction is prohibited
unless authorized in writing by HID Global Corporation.

WARNING:  Unauthorized reproduction of this program as well as
unauthorized preparation of derivative works based upon the
program or distribution of copies by sale, rental, lease or
lending are violations of federal copyright laws and state trade
secret laws, punishable by civil and criminal penalties.
--------------------------------------------------------------------------- */
import { BrowserModule } from '@angular/platform-browser';
import { importProvidersFrom, ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { provideRouter } from '@angular/router';

import { AppInitService } from './app.init';
import { AuthService } from './auth/auth.service';
import { routes } from './app.routes';
import { httpInterceptorProviders } from './auth/http-interceptors/interceptors';

// App init service
export function init_app(appLoadService: AppInitService) {
  return () => appLoadService.init();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    AuthService,
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      MatDialogModule,
      MatSnackBarModule,
      MatButtonModule
    ),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    httpInterceptorProviders,
    AppInitService,
    provideAppInitializer(() => {
        const initializerFn = (init_app)(inject(AppInitService));
        return initializerFn();
      })
  ]
};
